"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

var erros = _interopRequireWildcard(require("./errors-const"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NEW_PROMO_VIDEO_STATE = ['create-from-raw-video', 'create-from-uploaded-video', 'create-from-uploaded-photos'];

class ApiService {
  constructor(config) {
    if (config) {
      this.logger = config.logger || function () {};
    }
  }

  preperPromoVideoData(promoVideoData, state) {
    if (!promoVideoData) {
      throw erros.PROMO_VIDEO_DATA_MISSING;
    }

    if (!_.isString(state)) {
      throw erros.INVALID_PARMS;
    } // add guid to clips


    const {
      clips,
      decoration
    } = promoVideoData;
    clips.forEach(clip => {
      clip.guid = (0, _utils.generateGuid)();
      clip.type = clip.type || 'video';
    });

    if (promoVideoData.duration === null) {
      promoVideoData.duration = clips[clips.length - 1].timeline.end.timestamp;
    }

    const duration = promoVideoData.duration; // add times to decoration captions if needed and guid

    if (NEW_PROMO_VIDEO_STATE.includes(state)) {
      const captionsTimes = (0, _utils.getCaptionsTiming)(duration);
      let decorationData = decoration.decorationData; // add caption if need

      if (decorationData.length < captionsTimes.length) {
        const nocToAdd = captionsTimes.length - decorationData.length;
        const captionsToAdd = [];

        for (let i = 0; i < nocToAdd; i++) {
          captionsToAdd.push({ ...decorationData[(i + 1) % 2]
          });
        }

        decorationData = _.union(captionsToAdd, decorationData); // remove caption if need
      } else if (decorationData.length > captionsTimes.length) {
        decorationData = _.union(decorationData.slice(decorationData.length - captionsTimes.length), [decorationData[3]]);
      } // updat ecaption time and guid


      decorationData.forEach((caption, index) => {
        caption.timing = captionsTimes[index];
        caption.guid = (0, _utils.generateGuid)();
      });
      promoVideoData.decoration.decorationData = decorationData;
    }

    return promoVideoData;
  }

  updatePromoVideoData(promoVideoData) {
    if (!promoVideoData) {
      throw erros.PROMO_VIDEO_DATA_MISSING;
    }

    const {
      decoration
    } = promoVideoData;
    const outro = (0, _utils.getOutro)(decoration.decorationData);

    if (outro) {
      const lottie = (0, _utils.getFirstItemByLayout)(outro.children, 'lottie');
      const logoOutro = lottie.data.logo;
      const logo = (0, _utils.getFirstItemByLayout)(outro.children, 'LOGO');
      logo.data = {
        type: logoOutro.type,
        id: logoOutro.id,
        value: logoOutro.value
      };
      logo.style = { ...logo.style,
        ...logoOutro.style
      }; // update global logo legacy code

      promoVideoData.logo = {
        logoUrl: logoOutro.value,
        logoThumbUrl: logoOutro.value,
        logoBackgroundColor: logoOutro.style && logoOutro.style.backgroundColor ? logoOutro.style.backgroundColor : '',
        colorsPalette: '',
        id: logoOutro.id || ''
      }; // update duration by outro end

      promoVideoData.duration = outro.timing.end;
    }

    return promoVideoData;
  }

  getDuration(promoVideoData) {
    if (!promoVideoData) {
      throw erros.PROMO_VIDEO_DATA_MISSING;
    }

    const {
      decoration
    } = promoVideoData;
    const outro = (0, _utils.getOutro)(decoration.decorationData);
    return outro.timing.end;
  }

}

exports.default = ApiService;